import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { ExportOrderKey } from "../../models/domains/pbm/exports/export-order-key";
import { BackendUrl } from "../../models/domains/urls/back-end.url";

export interface IParamsNetworkFinancialstatmentPayment {
  StartDate: string;
  EndDate: string;
  CompanyFiscalNumber?: { Value: string };
}

@Injectable()
export class NetworkFinancialstatmentPaymentRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory) {}

  async analytic(params: IParamsNetworkFinancialstatmentPayment): Promise<ExportOrderKey> {
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const backEndUrl = new BackendUrl("/api/network/financial-statements-analytical");

      const data: any = await remoteGateway.postWithHeaders(backEndUrl, params, headers);
      const exportOrderKey = new ExportOrderKey(data.toString());
      return exportOrderKey;
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  async synthetic(params: IParamsNetworkFinancialstatmentPayment): Promise<ExportOrderKey> {
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const backEndUrl = new BackendUrl("/api/network/financial-statements-Synthetic");

      const data: any = await remoteGateway.postWithHeaders(backEndUrl, params, headers);
      const exportOrderKey = new ExportOrderKey(data.toString());
      return exportOrderKey;
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
